import { z } from 'zod'
import { Unit } from '@/shared/config/config'
import { Currency } from '@/shared/hooks/api/appConfig'

export enum EmissionReportStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED'
}

const carbonTaxPaidRawSchema = z.object({
  currency: z.enum(Currency).nullable(),
  effectiveCarbonPriceDue: z.string(),
  carbonPriceMechanismId: z.number().nullable(),
  exchangeRate: z.string(),
  embeddedEmissionsCovered: z.string(),
  embeddedEmissionsCoveredByRebate: z.string()
})

const endProductEmittingMethodInputSchema = z.object({
  id: z.number(),
  materialName: z.string(),
  deletedAt: z.date().optional().nullable(),
  proofFilePath: z.string(),
  quantityInTonnes: z.number(),
  type: z.enum(['OTHER_MATERIAL']),
  internalId: z.string().optional().nullable()
})

const electricityProductionMethodConfigSchema = z.object({
  consumption: z.number().gte(0),
  consumptionUnit: z.enum([Unit.TJ, Unit.MWh]),
  emissionFactor: z.number().gte(0),
  isEmissionFactorDefault: z.boolean(),
  fuelType: z.string().optional()
})

const electricityProductionConfigSchema = z.record(
  z.string(),
  electricityProductionMethodConfigSchema
)

const emissionReportPatchPayloadSchema = z.object({
  electricityProductionConfig: electricityProductionConfigSchema.optional(),
  carbonTaxPaidRaw: carbonTaxPaidRawSchema.nullable().optional(),
  endProductEmittingMethodInputs: z.array(endProductEmittingMethodInputSchema).optional()
})

const emissionReportSchema = z.object({
  id: z.string(),
  status: z.enum(EmissionReportStatus),
  submittedAt: z.string().nullable(),
  deletedAt: z.string().nullable(),
  createdAt: z.string(),
  installationId: z.string(),
  productionRouteId: z.string(),
  startDate: z.iso.date(),
  endDate: z.iso.date(),
  name: z.string(),
  ...emissionReportPatchPayloadSchema.shape,
  electricityProductionConfig: electricityProductionConfigSchema
})

export type EmissionReport = z.infer<typeof emissionReportSchema>
